{
  "version": 1,
  "asset_id": "daddee4d-da44-4f4f-bc6d-48500170ed84",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/daddee4d-da44-4f4f-bc6d-48500170ed84/scar-tissue-crura-esophagus-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/daddee4d-da44-4f4f-bc6d-48500170ed84/scar-tissue-crura-esophagus-es-480.webp",
  "original_filename": "scar-tissue-crura-esophagus-es-480.webp",
  "size": 39866,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:10Z"
}
